import revive_payload_client_4sVQNw7RlN from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import templates_pwa_client_657b680a_uQOv1L0WgD from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/.nuxt/templates.pwa.client.657b680a.ts";
import plugin_ybZ5mczHdl from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/nuxt-socket-io/lib/plugin.js";
import chunk_reload_client_UciE0i6zes from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_1UohGbtF8v from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import assets_client_MHsgPPxPuR from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/plugins/assets.client.ts";
import plyr_client_AWuhaKXXrg from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/plugins/plyr.client.ts";
import sentry_client_shVUlIjFLk from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/plugins/sentry.client.ts";
import socketIo_client_eZIbB39lDU from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/plugins/socketIo.client.ts";
import storageType_client_DvOPqM3FXv from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/plugins/storageType.client.ts";
import wakeLock_client_U0rBT5YdTh from "/home/jenkins/workspace/G4S/g4s_bhv_app/frontend/plugins/wakeLock.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  templates_pwa_client_657b680a_uQOv1L0WgD,
  plugin_ybZ5mczHdl,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_1UohGbtF8v,
  assets_client_MHsgPPxPuR,
  plyr_client_AWuhaKXXrg,
  sentry_client_shVUlIjFLk,
  socketIo_client_eZIbB39lDU,
  storageType_client_DvOPqM3FXv,
  wakeLock_client_U0rBT5YdTh
]